import { render, staticRenderFns } from "./addCollegeBanner.vue?vue&type=template&id=1bdbdc46&scoped=true&"
import script from "./addCollegeBanner.vue?vue&type=script&lang=js&"
export * from "./addCollegeBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bdbdc46",
  null
  
)

export default component.exports